
<button
class="form-group btn btn-sm btn-light text-nowrap"
id="viewButton"
data-bs-toggle="modal"
data-bs-target="#addDependent"
(click)="addDependentForm()"
>
Update
</button>



<!-- <div id="addDependent" class="modal fade modalposition modal-md" data-bs-backdrop="static"> -->
<div id="addDependent" class="modal my-custom-modal fade modalposition" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content" id="dependent-content">
            <div class="modal-header" id="backgroundColor">
                <span class="modal-title">Life Event Change</span>
                <i #closeDependentmodal class="bi bi-x-circle" role="button" aria-hidden="true"
                    data-bs-dismiss="modal" (click)="closeDependentForm()"></i>
            </div>
            <div class="modal-body" style="text-align: left; color:black">

        <div class="row">
            <div class="col-md-12 form-group">
                <label id="modal-labels"
                >Life event changes must be updated within 30 days of occurrence.<span style="color: red">*</span></label
                >
            </div>
        </div>
        <div class="row" style="margin-top:12px;" *ngIf="showDependentForm==false">
          <div class="col-12" style="width:100%; display: flex; justify-content: flex-start; gap: 15px; align-items: center;">
              <div style="display:flex; align-items:center;">
                <input
                type="radio"
                value="add"
                name="enactMode"
                [checked]="enactMode === 'add'"
                (click)="handleActionMode('add')"
                />&nbsp;<label id="radio-labels" class="align-text-top">Add Dependent</label>
              </div>
              <div  style="display:flex; align-items:center;" *ngIf="isSpouseExistsBefore == true">
                <input
          type="radio"
          value="cob"
          name="enactMode"
          [checked]="enactMode === 'cob'"
          (click)="handleActionMode('cob')"
          />&nbsp;<label id="radio-labels" class="align-text-top">Coordination of Benefits &nbsp;<i
            class="fa fa-info-circle"
            aria-hidden="true"
            title="If your dependents already have insurance (e.g., through a spouse or another parent), Coordination of Benefits (COB) helps decide which plan pays first and how benefits are shared."
            style="cursor: pointer;"
          ></i></label>
              </div>
              <div  style="display:flex; align-items:center;" *ngIf="isSpouseExistsBefore == true || isChildExistsBefore == true">
                <input
                type="radio"
                value="delete"
                name="enactMode"
                [checked]="enactMode === 'delete'"
                (click)="handleActionMode('delete')"
                />&nbsp;<label id="radio-labels" class="align-text-top">Remove a Dependent</label>
              </div>
              <div  style="display:flex; align-items:center;" *ngIf="isSpouseExistsBefore == true">
                <input
                type="radio"
                value="maritalChange"
                name="enactMode"
                [checked]="enactMode === 'maritalChange'"
                (click)="handleActionMode('maritalChange')"
                />&nbsp;<label id="radio-labels" class="align-text-top">Change Marital status</label>
              </div>
          </div>
        </div>
            
        <!-- dependet info -->
        <form [formGroup]="spouseform" *ngIf="showDependentForm==false && enactMode == 'add'" >
            
        <div class="row" style="display: flex;  align-items: center; margin-top: 5px; margin-bottom: 5px;" *ngIf="enactMode === 'add'">


            <div class="col-6 form-group">
            <label id="modal-labels">
                Dependent Type<span style="color: red">*</span>
            </label>
            <select class="form-select" formControlName="dependentType" (change)="changeDependent($event)">
                <option [ngValue]="null" disabled>Select Dependent Type</option>
                <option value="spouse" [disabled]="isSpouseExists == true || isSpouseInUnderwriting == true">Spouse &nbsp;<i
                  class="fa fa-info-circle"
                  aria-hidden="true"
                  *ngIf="isSpouseInUnderwriting == true"
                  title="We've received your spouse's policy and it's currently in the underwriting phase. You'll be notified once it's approved."
                  style="cursor: pointer;"
                ></i></option>
                <option value="multiple" [disabled]="isSpouseExists == true || isSpouseInUnderwriting == true">Spouse with child(ren) &nbsp;<i
                  class="fa fa-info-circle"
                  aria-hidden="true"
                  *ngIf="isSpouseInUnderwriting == true"
                  title="We've received your spouse's policy and it's currently in the underwriting phase. You'll be notified once it's approved."
                  style="cursor: pointer;"
                ></i></option>
                <option value="child">Child(ren)</option>
              </select>

              <div *ngIf="spouseform.get('dependentType')?.touched && spouseform.get('dependentType')?.invalid" class="help-block text-danger">
                <div *ngIf="spouseform.get('dependentType')?.errors?.['required']">Please select a dependent type</div>
              </div>
              
            </div>

            <div class="col-6 form-group" *ngIf="dependentType == 'spouse' || dependentType == 'multiple'">
            <label id="modal-labels"
                >Marital Type<span style="color: red">*</span></label
            >
            <div class="row" >
                <div class="col-6 mt-1" style="display: flex; align-items: center; gap:1px;">
                  <input
                  type="radio"
                  value="married"
                  name="maritalStatus"
                  formControlName="maritalStatus"
                  (click)="handleMaritalStatus('married')"
                />&nbsp;<label id="radio-labels" class="align-text-top">Married</label>
                </div>
                <div class="col-6 mt-1" style="display: flex; align-items: center; gap:1px;">
                    <input
                    type="radio"
                    value="commonLaw"
                    name="maritalStatus"
                    [checked]="maritalStatus === 'commonLaw'"
                    formControlName="maritalStatus"
                    (click)="handleMaritalStatus('commonLaw')"
                    required
                    />&nbsp;<label id="radio-labels" class="align-text-top">Common Law</label>
                </div>
               
                </div>


                
              <div *ngIf="spouseform.get('maritalStatus')?.touched && spouseform.get('maritalStatus')?.invalid" class="help-block text-danger">
                <div *ngIf="spouseform.get('maritalStatus')?.errors?.['required']">Please select marital type</div>
              </div>
            </div>


                    </div>

        <div class="row" style="display: flex;  align-items: center; margin-top: 5px; margin-bottom: 5px;" *ngIf="enactMode === 'add' &&  maritalStatus!=''">
            <div class="col-6 form-group" *ngIf="dependentType == 'spouse' || dependentType == 'multiple'">
                <label id="modal-labels" *ngIf="maritalStatus=='married'"
                    >Marriage Date<span style="color: red">*</span></label>
                    <label id="modal-labels" *ngIf="maritalStatus=='commonLaw'"
                    >Start date of Co-Habitation<span style="color: red">*</span></label>
                    <input
                    type="text"
                    placeholder="MM-DD-YYYY"
                    formControlName="dateOfMarriage"
                    (bsValueChange)="handleMarriageDate($event)"
                    class="form-control checking-field"
                    id="marriageDate"
                    [minDate]="minDatechild"
                    [maxDate]="maxDatechild"
                    bsDatepicker
                    [bsConfig]="{ dateInputFormat: 'MM-DD-YYYY' }"
                    />
                    <div *ngIf="spouseform.get('dateOfMarriage')?.touched && spouseform.get('dateOfMarriage')?.invalid" class="help-block text-danger">
                        <div *ngIf="spouseform.get('dateOfMarriage')?.errors?.['required'] && maritalStatus=='married'">Date of marriage is required</div>
                        <div *ngIf="spouseform.get('dateOfMarriage')?.errors?.['required'] && maritalStatus=='commonLaw'">Date of Co-Habitation is required</div>
                      </div>
                </div>
                <div class="col-6 form-group" *ngIf="normalSpouseRegistration == false">
                    <label id="modal-labels" *ngIf="maritalStatus=='married'"
                        >Reason for Late Submission of Marriage Details<span style="color: red">*</span></label>
                        <label id="modal-labels" *ngIf="maritalStatus=='commonLaw'"
                        >Reason for Late Submission of Co-Habitation Details<span style="color: red">*</span></label>
                        <input type="text" class="form-control" id="reasonForLate" formControlName="reasonForLate" />
                        <div *ngIf="spouseform.get('reasonForLate')?.touched && spouseform.get('reasonForLate')?.invalid" class="help-block text-danger">
                            <div *ngIf="spouseform.get('reasonForLate')?.errors?.['required']">Please enter reason for reporting late</div>
                          </div>
                          
                    </div>
        </div>


                    <div class="row"
                        *ngIf="enactMode === 'add' &&  maritalStatus!='' && dependentType == 'spouse' || dependentType == 'multiple'"
                        style="margin-top: 5px; margin-bottom: 5px;">
                        <div class="col-md-6 form-group">
                            <label id="modal-labels" *ngIf="dependentType == 'spouse' || dependentType == 'multiple'">Is your spouse currently covered by another health and/or dental insurance plan?
                                <span style="color: red">*</span></label>
                        </div>

            <div class="col-3 mt-1" style="display: flex; align-items: center; gap:1px;">
                <input
                  type="radio"
                  [value]="true"
                  name="coveredByAnotherPlan"
                  formControlName="coveredByAnotherPlan"
                  [checked]="coveredByAnotherPlan === 'open'"
                  (click)="handleChangeCurrentCoverage('open')"
                />&nbsp;<label id="radio-labels" class="align-text-top">{{
                  lang?.Yes
                }}</label>
              </div>
              <div class="col-3 mt-1" style="display: flex; align-items: center; gap:1px;">
                <input
                  type="radio"
                  [value]="false"
                  name="coveredByAnotherPlan"
                  formControlName="coveredByAnotherPlan"
                  [checked]="coveredByAnotherPlan === 'close'"
                  (click)="handleChangeCurrentCoverage('close')"
                />&nbsp;<label id="radio-labels" class="align-text-top">{{
                  lang?.No
                }}</label>
              </div>


              <div *ngIf="spouseform.get('coveredByAnotherPlan')?.touched && spouseform.get('coveredByAnotherPlan')?.invalid" class="help-block text-danger">
                <div *ngIf="spouseform.get('coveredByAnotherPlan')?.errors?.['required']">Please select coverage option</div>
              </div>
              
          </div>


          <div class="row" style="display: flex;  align-items: center; margin-top: 5px; margin-bottom: 5px;" *ngIf="enactMode === 'add' &&  maritalStatus!='' &&  dependentType == 'spouse' || dependentType == 'multiple'">
            
                <div class="col-5 form-group">
                        <label id="modal-labels"
                        >Spouse Full Name<span style="color: red">*</span></label>
                        <input type="text" class="form-control" id="spouseName" formControlName="fullName">
                        <div *ngIf="spouseform.get('fullName')?.touched && spouseform.get('fullName')?.invalid" class="help-block text-danger">
                            <div *ngIf="spouseform.get('fullName')?.errors?.['required']">Please enter your spouse’s full name</div>
                            <div *ngIf="spouseform.get('fullName')?.errors?.['minlength']">Full Name should be at least 2 characters</div>
                            <div *ngIf="spouseform.get('fullName')?.errors?.['fullNameInvalid'] && spouseform.get('fullName')?.touched">
                              Please enter both first and last name.
                            </div>
                          </div>
                          
                    </div>

                    <div class="col-3 form-group">
                        <label id="modal-labels"
                        >Date of Birth<span style="color: red">*</span></label>
                        <input
                        type="text"
                        placeholder="MM-DD-YYYY"
                        class="form-control checking-field"
                        id="spouseDob"
                        formControlName="dob"
                        [maxDate]="maxDatechild"
                        bsDatepicker
                        [bsConfig]="{ dateInputFormat: 'MM-DD-YYYY' }"
                        />

                        <div *ngIf="spouseform.get('dob')?.touched && spouseform.get('dob')?.invalid" class="help-block text-danger">
                            <div *ngIf="spouseform.get('dob')?.errors?.['required']">Select Date of Birth</div>
                          </div>

                          <div
                          *ngIf="
                            spouseForm['dob'].touched && spouseForm['dob'].status=='INVALID'
                          "
                          class="help-block text-danger"
                        >
                          <div
                            *ngIf="
                              spouseForm['dob'].errors &&
                              spouseForm['dob'].errors['ageError']
                            "
                          >
                            Date of Birth must be above 18
                          </div>
                        </div>
                          
                    </div>


                    <div class="col-4 form-group" *ngIf="coveredByAnotherPlan == 'open'">
                        <label id="modal-labels"
                        >Insurance carrier<span style="color: red">*</span></label>
                        <input type="text" class="form-control" id="insurer" formControlName="insurer">
                        <div
                  *ngIf="
                    spouseForm['insurer'].touched &&
                    spouseForm['insurer'].invalid
                  "
                  class="help-block text-danger"
                >
                  <div
                    *ngIf="
                      spouseForm['insurer'].errors &&
                      spouseForm['insurer'].errors['required']
                    "
                  >
                      Enter Insurer Carrier Details
                  </div>
                </div>
                    </div>
        </div>



        <div class="row" *ngIf="enactMode === 'add' &&  dependentType == 'multiple' || dependentType == 'child'" style="margin-top: 12px; margin-bottom: 5px;">
                <button
                type="button"
                class="btn btn-sm btn-light"
                id="updateButton"
                style="margin-left: 8px; width: 95px;"
                (click)="showAddDependentForm()"
                >
                Add Child
                </button>
            <div *ngIf="childrenDetails.length==0">
                <span style="font-size: 12px; font-style: italic; opacity: 80%;">No child(ren) to show</span>
            </div>


                        <div class="showChildDetailsTable" style="margin-top: 20px;" *ngIf="childrenDetails.length > 0">
                            <table id="table" class="beneficiaryTable">
                                <thead>
                                    <tr>
                                        <!-- <th>Benefactor</th> -->
                                        <!-- <th>Type</th> -->
                                        <th>{{ lang?.Name }}</th>
                                        <!-- <th>Name</th> -->

                                        <th>{{ lang?.Date_of_Birth }}</th>
                                        <th>Is Disabled</th>
                                        <th>Covered by another plan</th>
                                        <th class="text-center">{{ lang?.Action }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let child of childrenDetails; let i = index">
                                        <!-- <td><input class="form-control view text-capitalize" style="width:100px;" disabled ngModel={{child.customerType}}/></td> -->
                                        <!-- <td><input class="form-control view text-capitalize" style="width:120px;" disabled value={{removeUnderscores(child.type)}}/></td> -->
                                        <td class="text-center">
                                            {{child.fullName}}
                                        </td>

                                        <td class="text-center">
                                            {{momentDateformat(child.dob)}}
                                        </td>
                                        <td class="text-center">
                                            {{child.specialNeeds ? 'Yes' : 'No'}}
                                        </td>
                                        <td class="text-center">
                                            {{child.coveredByAnotherPlan ? 'Yes' : 'No'}}
                                        </td>
                                        <td class="text-center">
                                            <i class="fa fa-pencil" role="button" aria-hidden="true"
                                                (click)="updateChildDetails_v2(child, i)"></i>

                                            <i role="button" class="fa fa-trash-o" style="margin-left: 10px"
                                                aria-hidden="true" (click)="deleteChildDetails_v2(i)"></i>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>



                    <div class="row"
                        *ngIf="enactMode === 'add' && (
                                  (dependentType === 'spouse' && maritalStatus !== '') ||
                                  (dependentType === 'multiple') ||
                                  (dependentType === 'child' && childrenDetails.length > 0)
                              )"
                        style="margin-top: 5px; margin-bottom: 5px;">

                        <div class="col-md-6 form-group">
                            <label id="modal-labels" *ngIf="dependentType == 'spouse'">Would you like to add your spouse to your policy?
                                <span style="color: red">*</span></label>
                            <label id="modal-labels" *ngIf="dependentType == 'multiple'">Would you like to add Spouse/Child(ren) to your
                                policy?
                                <span style="color: red">*</span></label>
                            <label id="modal-labels" *ngIf="dependentType == 'child' && childrenDetails.length > 0">Would you like to add Child(ren) to your policy?
                                <span style="color: red">*</span></label>
                        </div>

            <div class="col-3 mt-1" style="display: flex; align-items: center; gap:1px;">
                <input
                  type="radio"
                  [value]="true"
                  name="addToPolicy"
                  [(ngModel)]="addToPolicy"
                  [checked]="addToPolicy === 'open'"
                  (click)="handleAddToPolicy('open')"
                />&nbsp;<label id="radio-labels" class="align-text-top">{{
                  lang?.Yes
                }}</label>
              </div>
              <div class="col-3 mt-1" style="display: flex; align-items: center; gap:1px;">
                <input
                  type="radio"
                  [value]="false"
                  name="addToPolicy"
                  [(ngModel)]="addToPolicy"
                  [checked]="addToPolicy === 'close'"
                  (click)="handleAddToPolicy('close')"
                />&nbsp;<label id="radio-labels" class="align-text-top">{{
                  lang?.No
                }}</label>
              </div>

              <div *ngIf="showAddToPolicyError"  class="help-block text-danger">
                <div>Please select policy change</div>
              </div>
          </div>

          <span *ngIf="firstMessage != ''" style="font-size: 12px; margin-top: 5px; margin-bottom: 5px;">{{firstMessage}}</span><br/>
          <span *ngIf="secondMessage != ''" style="margin-top: 5px; margin-bottom: 5px; font-size: 12px;">{{secondMessage}}</span>        

        </form>

        <!-- child information -->
        <form [formGroup]="dependentform" *ngIf="showDependentForm==true && enactMode == 'add'">

            <div class="isInsuranceCheck" style="display: flex; gap: 30px;">

        <div class="row" style="margin-top: 5px; margin-bottom: 5px;">
            <div class="col-md-6 form-group">
              <label id="modal-labels"
                >Is your Child currently covered by another Health and/or Dental Insurance plan?
                <span style="color: red">*</span></label
              >
            </div>

            <div class="col-2 mt-1" style="display: flex; align-items: center; gap:1px;">
                <input
                type="radio"
                [value]="true"
                name="coveredByAnotherPlan"
                formControlName="coveredByAnotherPlan"
                [checked]="childCoverage === true"
                (click)="openChildCoverage('open')"
            />&nbsp;<label id="radio-labels" class="align-text-top">{{
                lang?.Yes
            }}</label>
              </div>
              <div class="col-2 mt-1" style="display: flex; align-items: center; gap:1px;">
                <input
                type="radio"
                [value]="false"
                name="coveredByAnotherPlan"
                formControlName="coveredByAnotherPlan"
                [checked]="childCoverage === false"
                (click)="openChildCoverage('close')"
            />&nbsp;<label id="radio-labels" class="align-text-top">{{
                lang?.No
            }}</label>
              </div>
          </div>
        
        
    </div>


    <div class="row">
        <div class="col-6 form-group">
            <label id="modal-labels"
                >{{ lang?.Date_of_Birth
                }}<span style="color: red">*</span></label
            >
            <!-- <input type="text" id="dob" formControlName="dob" placeholder="mm-dd-yyyy" class="form-control date"> -->
            <input
                type="text"
                placeholder="MM-DD-YYYY"
                class="form-control checking-field"
                id="dob"
                formControlName="dob"
                [minDate]="minDatechild"
                [maxDate]="maxDatechild"
                bsDatepicker
                (bsValueChange)="handleChildDOBDate($event)"
                [bsConfig]="{ dateInputFormat: 'MM-DD-YYYY' }"
            />

            <div class="help-block text-danger" *ngIf="dependentForm['dob'].errors && dependentForm['dob'].touched">
              <div *ngIf="dependentForm['dob'].errors['required']">
                Select Date of birth
              </div>
              <div *ngIf="dependentForm['dob'].errors['childrenminimumAge']">
                Age must be below 21 years
              </div>
              <div *ngIf="dependentForm['dob'].errors['validGraduationDateBirth']">
                Please ensure the graduation date is greater than the date of birth
              </div>
            </div>


            <!-- <div
                *ngIf="
                dependentForm['dob'].touched && dependentForm['dob'].invalid
                "
                class="help-block text-danger"
            >
                <div
                *ngIf="
                    dependentForm['dob'].errors &&
                    dependentForm['dob'].errors['required']
                "
                >
                {{ lang?.Please_enter_Date_of_birth }}
                </div>
            </div> -->
            </div>
        
        <div class="col-6 form-group" *ngIf="childCoverage && normalDependentRegistration == false">
        <label id="modal-labels"
            >Reason for reporting late<span style="color: red">*</span></label
        >
        <input
            type="text"
            placeholder="Reason"
            class="form-control"
            formControlName="reasonForLate"
            id="reasonForLate"
            (keypress)="
            (($event.charCode >= 65 && $event.charCode < 91) ||
                ($event.charCode >= 97 && $event.charCode < 123) ||
                $event.charCode == 32)
            "
            (input)="checkFirstCharacter($event, pureDependentform)"
        />
        </div>
        
    </div>

    <div class="row">
        <div class="col-6 form-group">
        <label id="modal-labels"
            >Child Name<span style="color: red">*</span></label
        >
        <input
            type="text"
            placeholder="Child Name"
            id="fullName"
            formControlName="fullName"
            class="form-control"
            (keypress)="
            (($event.charCode >= 65 && $event.charCode < 91) ||
                ($event.charCode >= 97 && $event.charCode < 123) ||
                $event.charCode == 32)
            " (input)="checkFirstCharacter($event, pureDependentform)" />
                    <div *ngIf="
            dependentForm['fullName'].touched &&
            dependentForm['fullName'].invalid
            " class="help-block text-danger">
                        <div *ngIf="
                dependentForm['fullName'].errors &&
                dependentForm['fullName'].errors['required']
            ">
                            Please enter full name
                        </div>
                        <div *ngIf="
                dependentForm['fullName'].errors &&
                dependentForm['fullName'].errors['minlength']
            ">
                            Full Name should be atleast 2 character
                            <!-- {{
                lang?.First_Name_minimum_of_2_Characters_and_without_numbers
            }} -->
            </div>
            <div *ngIf="dependentform.get('fullName')?.errors?.['fullNameInvalid'] && dependentform.get('fullName')?.touched">
              Please enter both first and last name.
            </div>
        </div>
        </div>
        
        <div class="col-6 form-group" *ngIf="childCoverage && dependentChildCoverage === 'open'">
        <label id="modal-labels"
            >Insurance carrier<span style="color: red">*</span></label
        >
        <input
            type="text"
            placeholder="Name of the Carrier"
            class="form-control"
            formControlName="carrierName"
            id="carrierName"
            (keypress)="
            (($event.charCode >= 65 && $event.charCode < 91) ||
                ($event.charCode >= 97 && $event.charCode < 123) ||
                $event.charCode == 32)
            " (input)="checkFirstCharacter($event, pureDependentform)" />
                    <div *ngIf="
            dependentForm['carrierName'].touched &&
            dependentForm['carrierName'].invalid
            " class="help-block text-danger">
                        <div *ngIf="
                dependentForm['carrierName'].errors &&
                dependentForm['carrierName'].errors['required']
            ">
                            {{ lang?.Please_enter_name_of_carrier }}
                        </div>
                    </div>
                </div>

            </div>


            <div class="row mt-2">
                <div class="col-6 mt-1" style="display: flex; align-items: center; gap:1px;">
                    <input type="checkbox" value="true" formControlName="specialNeeds"
                        [checked]="specialNeeds === 'true'" />&nbsp;<label id="radio-labels"
                        class="align-text-top">{{
                        lang?.Dependent_with_Special_Needs
                        }}</label>
                </div>
                <!-- <div *ngIf="dependentForm['specialNeeds'].touched && dependentForm['specialNeeds'].invalid" class="help-block text-danger">
                        <div *ngIf="dependentForm['specialNeeds'].errors && dependentForm['specialNeeds'].errors['required']">Please enter</div>
                    </div> -->
            </div>
            <div class="row mt-2">

                <div class="col-5 mt-1" style="display: flex; align-items: center; gap:1px;">
                    <input type="checkbox" value="true" formControlName="postSecondaryStudent"
                        [checked]="postSecondaryStudent === true"
                        (change)="openGraduationDate($event)" />&nbsp;<label id="radio-labels"
                        class="align-text-top">{{ lang?.Post_Secondary_Student }}</label>
                </div>


                <div class="col-3 form-group" *ngIf="postSecondaryStudent && graduationDate">
                    <label id="modal-labels">{{ lang?.Graduation_Day
                        }}<span style="color: red">*</span></label>
                    <!-- <input type="text" placeholder="mm-dd-yyyy" class="form-control date" name="graduationDate" formControlName="graduationDate"> -->
                    <input type="text" placeholder="MM-DD-YYYY" class="form-control checking-field"
                        name="graduationDate" formControlName="graduationDate" placement="top"
                        [minDate]="minDatechild" [maxDate]="maxDatechild" bsDatepicker
                        [bsConfig]="{ dateInputFormat: 'MM-DD-YYYY' }" />
                    <!-- <div *ngIf="dependentForm['postSecondaryStudent'].touched && dependentForm['postSecondaryStudent'].invalid" class="help-block text-danger">
                        <div *ngIf="dependentForm['postSecondaryStudent'].errors && dependentForm['postSecondaryStudent'].errors['required']">lang?.Please_enter_first_name</div>
                    </div> -->


                    <div class="help-block text-danger" *ngIf="dependentForm['graduationDate'].errors && dependentForm['graduationDate'].touched">
                      <div *ngIf="dependentForm['graduationDate'].errors['required']">
                        Please choose graduation date
                      </div>
                      <div *ngIf="dependentForm['graduationDate'].errors['validGraduationDate']">
                        Please ensure the graduation date is greater than the date of birth
                      </div>
                      <div *ngIf="dependentForm['graduationDate'].errors['dateOfBirth']">
                        Select Date of birth
                      </div>
                    </div>


                    <!-- <div *ngIf="isGradError" class="help-block text-danger">
                      <div>Graduation date cannot be less than date of birth</div>
                  </div> -->
                </div>


                <!-- <div *ngIf="dependentCoverage === 'open'" class="col-3 form-group">
        <label id="modal-labels"
            >Upgrade Plan<span style="color: red">*</span>
            <i style="margin-left: 5px;" class="fa fa-info-circle" title="Upgrading your plan will result in a price change, but you can keep the same coverage." aria-hidden="true"></i>
            </label
        >
        <select class="form-select" formControlName="upgradePlan" (change)="handleUpgradePlan2($event)">
            <option value="" disabled>Select</option>
            <option
            value="true"
        >
            Yes
        </option>
            <option
            value="false"
        >
            No
        </option>
        </select>
        <div
            *ngIf="
            dependentForm['carrierName'].touched &&
            dependentForm['carrierName'].invalid
            "
            class="help-block text-danger"
        >
            <div
            *ngIf="
                dependentForm['carrierName'].errors &&
                dependentForm['carrierName'].errors['required']
            "
            >
            {{ lang?.Please_enter_name_of_carrier }}
            </div>
        </div>
        </div> -->


                <div *ngIf="
            dependentForm['graduationDate'].touched &&
            dependentForm['graduationDate'].invalid
        " class="help-block text-danger">
                    <div *ngIf="
            dependentForm['graduationDate'].errors &&
            dependentForm['graduationDate'].errors['required']
            ">
                        {{ lang?.Please_choose_graduation_date }}
                    </div>
                </div>
            </div>

        </form>

        <form [formGroup]="cobform" *ngIf="enactMode == 'cob'" >
          

          <div *ngIf="isSpouseExistsBefore == false">
            <span style="font-size: 12px;">Please add dependent first.</span>
          </div>

            <div *ngIf="isSpouseExistsBefore == true">
            <div class="row" style="display: flex;  align-items: center; margin-top: 5px; margin-bottom: 5px;">
              
                      <div class="col-6 form-group">
                          <label id="modal-labels"
                          >Spouse's Insurance carrier<span style="color: red">*</span></label>
                          <input type="text" class="form-control" id="insurer" formControlName="insurer">

                          <div
                          *ngIf="cobform.get('insurer')?.invalid && cobform.get('insurer')?.touched"  class="help-block text-danger">
                          Please enter insurer carrier details
                      </div>
                      </div>

                     

                      <div class="col-6 form-group">
                        <label id="modal-labels">
                         Coordination of Benefits (COB) Coverage<span style="color: red">*</span>
                        </label>
                        <select class="form-select" formControlName="cobCoverage" (change)="changeCOBCoverage($event)">
                            <option [ngValue]="null" disabled>Select coverage</option>
                            <option value="SINGLE">Single</option>
                            <option value="COUPLE">Couple</option>
                            <option value="FAMILY">Family</option>
                          </select>


                          <div
                          *ngIf="cobform.get('cobCoverage')?.invalid && cobform.get('cobCoverage')?.touched"  class="help-block text-danger">
                          Please select cob coverage
                      </div>
                          </div>

                          


          </div>
                      <div class="row"
                          *ngIf="enactMode === 'cob'"
                          style="margin-top: 5px; margin-bottom: 5px;">
                          <div class="col-6" *ngIf="isExcludeSpouse || isExcludeChildAndSpouse || isExcludeAll">
                            <div class="col-md-12 form-group">
                              <label id="modal-labels" *ngIf="isExcludeSpouse == true">Do you want to change your coverage?
                                  <span style="color: red">*</span></label>
                              <label id="modal-labels" *ngIf="isExcludeChildAndSpouse == true">Do you want to change your coverage?
                                  <span style="color: red">*</span></label>
                              <label id="modal-labels" *ngIf="isExcludeAll == true">Do you want to change your coverage?
                                  <span style="color: red">*</span></label>
                          </div>

                          <div class="row" *ngIf="isExcludeSpouse || isExcludeChildAndSpouse || isExcludeAll">
                            <div class="col-6 mt-1" style="display: flex; align-items: center; gap:1px;">
                                <input  
                                  type="radio"
                                  [value]="true"
                                  name="addToPolicy"
                                  [(ngModel)]="addToPolicy"
                                  [checked]="addToPolicy === 'open'"
                                  (click)="handleKeepDependentsToCurrent('open')"
                                />&nbsp;<label id="radio-labels" class="align-text-top">{{
                                  lang?.Yes
                                }}</label>
                              </div>
                              <div class="col-6 mt-1" style="display: flex; align-items: center; gap:1px;">
                                <input
                                  type="radio"
                                  [value]="false"
                                  name="addToPolicy"
                                  [(ngModel)]="addToPolicy"
                                  [checked]="addToPolicy === 'close'"
                                  (click)="handleKeepDependentsToCurrent('close')"
                                />&nbsp;<label id="radio-labels" class="align-text-top">{{
                                  lang?.No
                                }}</label>
                              </div>
                
                              <div *ngIf="showAddToPolicyError"  class="help-block text-danger">
                                <div>Please select an option</div>
                              </div>
                                    </div>
                          </div>
                          


                          

                      </div>
                  
            <span *ngIf="needToUpdate != ''" style="font-size: 12px;">{{needToUpdate}}</span> <br/>
            <span *ngIf="firstMessage != ''" style="font-size: 12px; margin-top: 5px; margin-bottom: 5px;">{{firstMessage}}</span><br/>
            <span *ngIf="secondMessage != ''" style="margin-top: 5px; margin-bottom: 5px; font-size: 12px;">{{secondMessage}}</span>       
          </div>
          </form>

        <form [formGroup]="deleteForm" *ngIf="enactMode == 'delete'">
          <div *ngIf="availableFirstNames.length == 0">
            <span style="font-size: 12px;">No dependents to remove</span>
          </div>
          <div *ngIf="availableFirstNames.length > 0">
            <div class="row">
                <div class="col-md-6 form-group">
                    <label id="modal-labels">Dependent Name</label>
                    <select class="form-select" (change)="onDependentChange($event)"  formControlName="selectedDepId" style="font-size: 12px;">
                      <option value="" disabled selected>Select dependent</option>
                      <option *ngFor="let name of availableFirstNames" [value]="name.id">
                        {{ name.firstName }} {{name.lastName}} - {{name.relationType}}
                      </option>
                    </select>
                  </div>

                <div class="col-md-6 form-group">
                    <label id="modal-labels">Reason for removal<span style="color: red">*</span></label>
                    <select formControlName="deletionReason" class="form-select">
                        <option value="">Select a reason</option>
                        <option value="spouse_died" *ngIf="dependentType == 'spouse'">Spouse deceased</option>
                        <option value="spouse_died" *ngIf="dependentType == 'child'">Child died</option>
                        <option value="spouse_died" *ngIf="dependentType == 'child'">Child agedout</option>
                        <option value="divorced" *ngIf="dependentType == 'spouse'">Divorced</option>
                        <option value="divorced" *ngIf="dependentType == 'spouse'">Seperated</option>
                        <option value="other">Other</option>
                    </select>
                    <div  class="help-block text-danger"
                        *ngIf="deleteForm.get('deletionReason')?.invalid && deleteForm.get('deletionReason')?.touched">
                        Please select a reason.
                    </div>
                </div>

            </div>

            <div class="row" >
                <div class="col-md-6 form-group" *ngIf="deleteForm.get('deletionReason')?.value === 'other'">
                    <label id="modal-labels">Please specify<span style="color: red">*</span></label>
                    <input type="text" class="form-control" id="otherReason" formControlName="otherReason">
                    <div  class="help-block text-danger"
                        *ngIf="deleteForm.get('otherReason')?.invalid && deleteForm.get('otherReason')?.touched">
                        Please provide a reason.
                    </div>
                </div>

                <!-- <div class="col-md-6 form-group">
                    <label id="modal-labels">Effective date<span style="color: red">*</span></label>
                    <input type="text" placeholder="MM-DD-YYYY" class="form-control checking-field"
                        formControlName="effectiveDate" [minDate]="minDatechild"
                        bsDatepicker [bsConfig]="{ dateInputFormat: 'MM-DD-YYYY' }" (bsValueChange)="onEffectiveDateChange($event)" />
                    <div
                        *ngIf="deleteForm.get('effectiveDate')?.invalid && deleteForm.get('effectiveDate')?.touched"  class="help-block text-danger">
                        Please select an effective date.
                    </div>
                </div> -->
            </div>

            <span *ngIf="firstMessage != ''" style="font-size: 12px; margin-top: 5px; margin-bottom: 5px;">{{firstMessage}}</span><br/>
            <span *ngIf="secondMessage != ''" style="margin-top: 5px; margin-bottom: 5px; font-size: 12px;">{{secondMessage}}</span> 
          </div>
          </form>


        <form [formGroup]="maritalStatusform" *ngIf="enactMode == 'maritalChange'" >
          <div class="row" style="display: flex;  align-items: center; margin-top: 5px; margin-bottom: 5px;">       

                    <div class="col-6 form-group">
                      <label id="modal-labels">
                        Marital status<span style="color: red">*</span>&nbsp;<i
                        class="fa fa-info-circle"
                        aria-hidden="true"
                        title="only marital status change but retaining coverage as is"
                        style="cursor: pointer;"
                      ></i>
                      </label>
                      <select class="form-select" formControlName="maritalStatus" (change)="handlemaritalstatustype($event)">
                          <option [ngValue]="null" disabled>Select marital status</option>
                          <option value="DIVORCED">Divorced</option>
                          <option value="SEPERATED">Separated</option>
                          <option value="COMMONLAW">Common law</option>
                          <option value="MARRIED">Married</option>
                          <option value="other">Others</option>
                        </select>


                        <div
                        *ngIf="cobform.get('maritalStatus')?.invalid && cobform.get('maritalStatus')?.touched"  class="help-block text-danger">
                        Please select marital status
                    </div>
                    </div>

                    <div class="col-md-6 form-group" *ngIf="maritalStatusform.get('maritalStatus')?.value === 'other'">
                      <label id="modal-labels">Please specify reason<span style="color: red">*</span></label>
                      <input type="text" class="form-control" id="insurer" formControlName="reason">
                      <div  class="help-block text-danger"
                          *ngIf="maritalStatusform.get('reason')?.invalid && maritalStatusform.get('reason')?.touched">
                          Please provide a reason.
                      </div>
                  </div>

                  <div class="col-md-6 form-group" *ngIf="showSpouseDropDownForDelete">
                    <label id="modal-labels">Dependent Name</label>
                    <select
                      class="form-select"
                      (change)="onDependentSelectForms($event)"
                      style="font-size: 12px;"
                    >
                      <option value="" disabled selected>Select dependent</option>
                      <option *ngFor="let name of availableFirstNames" [value]="name.id">
                        {{ name.firstName }} {{ name.lastName }} - {{ name.relationType }}
                      </option>
                    </select>
                  </div>

                        


        </div>
                
        </form>

        
                   <div class="cols-span-full" *ngIf="showCorpPlansTable == true">
                      <label for="cardnumnber"><strong>All plans summary</strong></label>

                      <div>
                        <table id="table" class="beneficiaryTable">
                          <tbody>
                            <tr>
                              <!-- <th>S. no</th> -->
                              <th>Plan</th>
                              <!-- <th>Company Share</th>
                                      <th>Employee Share</th> -->
                              <th>Type</th>
                              <th class="taxamount">Premium</th>
                              <!-- <td>Plan</td> -->
                              <!-- <th class="taxamount">Tax Percentage</th> -->

                              <th class="taxamount">Tax</th>
                              <th class="taxamount">Total</th>
                            </tr>
                            <tr *ngFor="
                                        let item of allSelectedPlans;
                                        let i = index
                                      ">
                              <!-- <td>{{i+1}}</td> -->
                              <!-- {{item.groupName | lowercase}}- -->
                              <td *ngIf="item.isBundle==true;else productname">

                                <!-- ({{ item.packagename }}) -  -->
                                <span *ngIf="item.coveredByCompany==1;else noupgrade">{{ item.upgradeCalculation.planName }}</span>
                                <ng-template #noupgrade>{{item.planname}}</ng-template>

                              </td>

                              <ng-template #productname>
                                <td>
                                  <!-- ({{ item.packagename }}) -  -->
                                  <span *ngIf="item.coveredByCompany==1;else noupgrade1">{{ item.upgradeCalculation.planName
                                    }}</span>
                                  <ng-template #noupgrade1>{{item.planproductname}}</ng-template>
                                </td>
                              </ng-template>

                              <!-- <td>{{item.companyAmountUI}}</td>
                                      <td>{{item.employeeAmountUI}}</td> -->
                              <td>{{item.type}}</td>
                              <td class="grandTotal amounts" *ngIf="employercheck">

                                ---
                              </td>
                              <td class="grandTotal amounts" *ngIf="!employercheck">

                                <span *ngIf="item.coveredByCompany==1;else noupgradeprice">{{ currencySymbol }}{{
                                  item.upgradeCalculation.combinedplanPrice | number: "1.2-2"}}</span>
                                <ng-template #noupgradeprice>{{ currencySymbol }}{{ item.planPrice | number: "1.2-2"
                                  }}</ng-template>

                              </td>
                              <!-- <td>{{item.planCoverage}}</td> -->
                              <!-- <td>taxRateperecnatge&&taxtype</td> -->
                              <td class="grandTotal amounts" *ngIf="employercheck">
                                ---
                              </td>
                              <td class="grandTotal amounts" *ngIf="!employercheck">
                                <span *ngIf="item.coveredByCompany==1;else noupgradetax">{{ currencySymbol }}{{
                                  item.upgradeCalculation.combinedplanTax | number: "1.2-2"}}</span>
                                <ng-template #noupgradetax>{{ currencySymbol }}{{item.tax | number: "1.2-2"}}</ng-template>

                              </td>

                              <td class="grandTotal amounts" *ngIf="employercheck">
                                ---
                              </td>
                              <td class="grandTotal amounts" *ngIf="!employercheck">
                                <span *ngIf="item.coveredByCompany==1;else noupgradetotal">{{ currencySymbol }}{{
                                  item.upgradeCalculation.combinedplanTotal | number: "1.2-2"}}</span>
                                <ng-template #noupgradetotal>{{ currencySymbol }}{{ item.totalPrice | number: "1.2-2"
                                  }}</ng-template>

                              </td>
                            </tr>

                            <tr style="background-color: #D08000 ;">
                              <td>Total</td>
                              <td></td>
                              <td class="grandTotal amounts" *ngIf="employercheck">---</td>
                              <td class="grandTotal amounts" *ngIf="!employercheck">{{ currencySymbol}}{{ allPlansAmountTotal |
                                number: "1.2-2" }}</td>
                              <td class="grandTotal amounts" *ngIf="employercheck">---</td>
                              <td class="grandTotal amounts" *ngIf="!employercheck">{{ currencySymbol
                                }}{{allPlansTotaltax | number: "1.2-2"}}</td>
                              <td class="grandTotal amounts" *ngIf="employercheck">
                                ---
                              </td>
                              <td class="grandTotal amounts" *ngIf="!employercheck">
                                <b>{{ currencySymbol
                                  }}{{ allPlansTotal | number: "1.2-2" }}</b>
                              </td>
                            </tr>


                            <tr>
                              <td>
                              <td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr style="background-color: black">
                              <td style="color:white">Monthly payment summary
                              <td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                            <tr *ngIf="companyDealingPlans.length == 0 ? false : true">
                              <td><b>company pays</b>
                              <td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr *ngFor="let companypay of companyDealingPlans">

                              <td>
                                <span
                                  *ngIf="companypay.upgradeCalculation;else normalname">{{companypay.upgradeCalculation.compnayShareStatement}}</span>
                                <ng-template #normalname>
                                  {{companypay.planname}}
                                </ng-template>

                              </td>
                              <td>{{companypay.type}}</td>


                              <td class="grandTotal amounts" *ngIf="employercheck">
                                ---
                              </td>
                              <td class="grandTotal amounts" *ngIf="!employercheck">
                                <span *ngIf="companypay.upgradeCalculation;else normalamount">{{ currencySymbol
                                  }}{{ companypay.upgradeCalculation.baseplanPrice | number: "1.2-2" }}</span>
                                <ng-template #normalamount>
                                  {{ currencySymbol
                                  }}{{ companypay.amount | number: "1.2-2" }}
                                </ng-template>
                              </td>
                              <td class="grandTotal amounts" *ngIf="employercheck">
                                ---
                              </td>
                              <td class="grandTotal amounts" *ngIf="!employercheck">
                                <span *ngIf="companypay.upgradeCalculation;else normaltax">{{ currencySymbol
                                  }}{{ companypay.upgradeCalculation.baseplanTax | number: "1.2-2" }}</span>

                                <ng-template #normaltax>
                                  {{ currencySymbol
                                  }}{{ companypay.tax | number: "1.2-2" }}
                                </ng-template>
                              </td>
                              <td class="grandTotal amounts" *ngIf="employercheck">
                                ---
                              </td>
                              <td class="grandTotal amounts" *ngIf="!employercheck">
                                <span *ngIf="companypay.upgradeCalculation;else normaltotal">
                                  <b>{{ currencySymbol}}{{ companypay.upgradeCalculation.baseplanTotal | number: "1.2-2"
                                    }}</b></span>

                                <ng-template #normaltotal>
                                  <b>{{ currencySymbol
                                    }}{{ companypay.total | number: "1.2-2" }}</b>
                                </ng-template>
                              </td>



                            </tr>

                            <tr *ngIf="payrollCCplansarr.length == 0 ? false : true">
                              <td><b>Employee pays through payroll deduction </b>
                              <td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr *ngFor="let companypay of payrollCCplansarr">

                              <td>
                                <span
                                  *ngIf="companypay.upgradeCalculation;else normalname">{{companypay.upgradeCalculation.employeeShareStatement}}</span>
                                <ng-template #normalname>
                                  {{companypay.planname}}
                                </ng-template>

                              </td>
                              <td>{{companypay.type}}</td>

                              <td class="grandTotal amounts">
                                <span *ngIf="companypay.upgradeCalculation;else normalamount">{{ currencySymbol
                                  }}{{ companypay.upgradeCalculation.deltaplanPrice | number: "1.2-2" }}</span>
                                <ng-template #normalamount>
                                  {{ currencySymbol
                                  }}{{ companypay.amount | number: "1.2-2" }}
                                </ng-template>
                              </td>
                              <td class="grandTotal amounts">
                                <span *ngIf="companypay.upgradeCalculation;else normaltax">{{ currencySymbol
                                  }}{{ companypay.upgradeCalculation.deltaplanTax | number: "1.2-2" }}</span>

                                <ng-template #normaltax>
                                  {{ currencySymbol
                                  }}{{ companypay.tax | number: "1.2-2" }}
                                </ng-template>
                              </td>
                              <td class="grandTotal amounts">
                                <span *ngIf="companypay.upgradeCalculation;else normaltotal">
                                  <b>{{ currencySymbol}}{{ companypay.upgradeCalculation.deltaplanTotal | number: "1.2-2"
                                    }}</b></span>

                                <ng-template #normaltotal>
                                  <b>{{ currencySymbol
                                    }}{{ companypay.total | number: "1.2-2" }}</b>
                                </ng-template>
                              </td>
                            </tr>

                            <tr style="background-color: #D08000" *ngIf="employercheck">

                              <td>Total charge to Company</td>
                              <td></td>
                              <td class="grandTotal amounts">---</td>
                              <td class="grandTotal amounts">---</td>
                              <td class="grandTotal amounts">
                                <b>---</b>


                              </td>
                            </tr>
                            <tr style="background-color: #D08000" *ngIf="!employercheck">

                              <td>Total charge to Company</td>
                              <td></td>
                              <td class="grandTotal amounts">{{ currencySymbol
                                }}{{ companydealingplansTotal | number: "1.2-2" }}</td>
                              <td class="grandTotal amounts">{{ currencySymbol
                                }}{{ companydealingplanstaxTotal | number: "1.2-2" }}</td>
                              <td class="grandTotal amounts">
                                <b>{{ currencySymbol
                                  }}{{ companydealingplansgrandTotal | number: "1.2-2" }}</b>


                              </td>
                            </tr>
                            <tr>
                              <td>
                              <td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr *ngIf="employeeDealingPlansarr.length == 0 ? false : true">
                              <td><b>Employee pays through CC PAD </b>
                              <td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr *ngFor="let companypay of employeeDealingPlansarr">

                              <td>
                                <!-- <span *ngIf="companypay.upgradeCalculation;else normalname">{{companypay.upgradeCalculation.compnayShareStatement}}</span> -->
                                <!-- <ng-template > -->
                                {{companypay.planname}}
                                <!-- </ng-template> -->

                              </td>
                              <td>{{companypay.type}}</td>

                              <td class="grandTotal amounts">
                                <!-- <span *ngIf="companypay.upgradeCalculation;else normalamount">{{ currencySymbol
                                        }}{{ companypay.upgradeCalculation.deltaplanPrice | number: "1.2-2" }}</span> -->
                                <!-- <ng-template> -->
                                {{ currencySymbol
                                }}{{ companypay.amount | number: "1.2-2" }}
                                <!-- </ng-template> -->
                              </td>
                              <td class="grandTotal amounts">
                                <!-- <span *ngIf="companypay.upgradeCalculation;else normaltax">{{ currencySymbol
                                        }}{{ companypay.upgradeCalculation.deltaplanTax | number: "1.2-2" }}</span> -->

                                <!-- <ng-template> -->
                                {{ currencySymbol
                                }}{{ companypay.tax | number: "1.2-2" }}
                                <!-- </ng-template> -->
                              </td>
                              <td class="grandTotal amounts">
                                <!-- <span *ngIf="companypay.upgradeCalculation;else normaltotal">
                                      <b>{{ currencySymbol}}{{ companypay.upgradeCalculation.deltaplanTotal | number: "1.2-2" }}</b></span> -->

                                <!-- <ng-template > -->
                                <b>{{ currencySymbol
                                  }}{{ companypay.total | number: "1.2-2" }}</b>
                                <!-- </ng-template> -->
                              </td>
                            </tr>


                            <tr style="background-color: #D08000" *ngIf="employeeDealingPlansarr.length == 0 ? false : true">

                              <td>Total charge to Employee</td>
                              <td></td>

                              <td class="grandTotal amounts">{{ currencySymbol
                                }}{{ empDirectpayPlanamountTotal | number: "1.2-2" }}</td>
                              <td class="grandTotal amounts">{{ currencySymbol
                                }}{{ empDirectpayPlantaxTotal | number: "1.2-2" }}</td>
                              <td class="grandTotal amounts">
                                <b>{{ currencySymbol
                                  }}{{ empDirectpayPlangrandTotal | number: "1.2-2" }}</b>


                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <!-- <table>
                                <label>Monthly payment Sumamry</label>
                                <tr></tr>
                              </table> -->
                      </div>
                    </div>
                <!-- <div class="plansscreen" *ngIf="canShowPlans"> -->
                <div *ngIf="showPlanDetails == true && specialpackages?.length > 0"   style="margin-top: 800px;" class="plansscreen">
                    <div *ngFor="let package of specialpackages">
                      <div
                        class="d-flex gap-1"
                        *ngIf="isGroupsNotEmpty(package.groups)"
                      >
                        <span style="color: black; font-size: 12px;margin-top: 10px;"
                          >{{ package.name }}
                          <!-- <span title="Restricted"
                            *ngIf="package.restrictedAccess" class="ps-1">(R)</span>-->
                        </span>
                        <div
                          *ngIf="role === 'ADMINISTRATOR'"
                          title="{{
                            getTextForTooltip1(
                              package.published,
                              package.restrictedAccess
                            )
                          }}"
                          [ngStyle]="{
                            'border-color': getColorForPlans1(
                              package.published,
                              package.restrictedAccess
                            )
                          }"
                          class="outer my-auto col-2"
                          data-bs-toggle=""
                        >
                          <span
                            class="inner"
                            [ngStyle]="{
                              background: getColorForPlans1(
                                package.published,
                                package.restrictedAccess
                              )
                            }"
                          ></span>
                        </div>
                                      </div>
        
                      <div
                        *ngIf="displayPackage"
                        [ngClass]="{ wraptext: displayPackage }"
                        class="m-1 p-3"
                      >
                        <div
                          *ngFor="let groups of package?.groups | keyvalue"
                          class="d-flex gap-3 overflow-hidden"
                        >
                          <div *ngFor="let group of getGroups(groups)">
                            <div
                              *ngFor="let plan of group.plans; let i = index"
                              class="d-flex flex-wrap gap-3"
                            >
                              <div
                                class="package-groups col-md-4 mt-2"
                                *ngFor="
                                  let product of plan.productAddonssNames;
                                  let j = index
                                "
                                title=""
                              >
                                <div
                                  (mouseover)="hoverStates[product] = true"
                                  (mouseout)="hoverStates[product] = false"
                                  class="plantitle d-flex gap-3"
                                  [style.background-color]="
                                    plan.isBundle == false
                                      ? plan.productAddonss[product][0]?.planlevel
                                          ?.backgroundColor || '#5E172E'
                                      : group.backgroundColor || '#5E172E'
                                  "
                                >
                                  <span
                                    *ngIf="role === 'ADMINISTRATOR'"
                                    title="{{
                                      getTextForTooltip(
                                        plan.published?.data[0],
                                        plan.restricted
                                      )
                                    }}"
                                    [ngStyle]="{
                                      'border-color': getColorForPlans(
                                        plan.published?.data[0],
                                        plan.restricted,
                                        plan.name,
                                        plan
                                      )
                                    }"
                                    class="outer1 my-auto"
                                    data-bs-toggle=""
                                  >
                                    <span
                                      class="inner"
                                      [ngStyle]="{
                                        background: getColorForPlans(
                                          plan.published?.data[0],
                                          plan.restricted,
                                          plan.name,
                                          plan
                                        )
                                      }"
                                    ></span>
                                  </span>
                                  <span
                                    class="productname"
                                    [title]="product.length > 20 ? product : ''"
                                    [class.marquee]="
                                      product.length > 20 && hoverStates[product]
                                    "
                                    >{{
                                      product.length > 20
                                        ? hoverStates[product]
                                          ? product
                                          : (product | slice : 0 : 20) + "..."
                                        : product
                                    }}
                                    <!-- <span title="Restricted" *ngIf="plan.restricted"
                                      class="text-white pe-1">(R)</span> -->
                                  </span>
                                </div>
        
                                <!-- <div *ngIf=" plan.isBundle==true;else planfeature">
                                  <div class="planbody" *ngIf="group.planLevelFeatures">
        
                                    <li class="featuutrebody"
                                      *ngFor="let features of group.planLevelFeatures">
                                      <strong>{{ features.feature.name }}</strong> <br />
                                      <p [innerHTML]="features.description"></p>
                                    </li>
                                  </div>
                                </div> -->
        
                                <!-- <ng-template #planfeature>
                                  <div class="planbody"
                                    *ngIf="plan.productAddonss[product][0].planlevel.planLevelFeatures">
        
                                    <li class="featuutrebody"
                                      *ngFor="let features of plan.productAddonss[product][0].planlevel.planLevelFeatures">
                                      <strong>{{ features.feature.name }}</strong> <br />
                                      <p [innerHTML]="features.description"></p>
                                    </li>
                                  </div>
        
                                </ng-template> -->
        
                                <div class="plancoverage">
                                  <li
                                    class="plansCoverageDetails"
                                    *ngFor="
                                      let coverage of plan.productAddonss[product];
                                      let k = index
                                    "
                                  >
                                    <div *ngIf="coverage?.isShown==true"
                                      class="d-flex justify-content-between"
                                      [style.color]="
                                        plan.isBundle == false
                                          ? plan.productAddonss[product][0]?.planlevel
                                              ?.backgroundColor || '#5E172E'
                                          : group.backgroundColor || '#5E172E'
                                      "
                                      title="{{ coverage.planCoverageUI }}"
                                    >
                                      <div class="d-flex my-auto gap-1">
                                        <div class="my-auto">
                                          <!-- [disabled]="package.selected" -->
                                          <input type="checkbox" #planCheckdetails
                                          id="plancheck{{plan.isBundle ? plan.id : plan.productAddonss[product][k].planlevel.id }}"
                                          class="plancheckbox{{ package.id }} plancv newPlan{{plan.id}} coverage{{coverage.planCoverageUI | uppercase}}"
                                          attr.data="{{ package.name }}##{{ group.name }}##{{
                                          plan.planCoverage
                                        }}##{{
                                          plan.productAddonss[product][k].calculatedTax.price
                                        }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                                          plan.frqMonthly
                                        }}##{{ package.optIn }}##{{ group.disallowedPlanLevels }}##{{
                                          group.parentId
                                        }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                                          plan.packageId
                                        }}##0##{{ plan.planOptions }}##{{
                                          plan.productAddonss[product][k].id
                                        }}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}##{{ group.disallowedPlanLevels }}"
        
                                            (change)="
                                            onCheckboxChange(
                                              $event,
                                              package.allowMultiple,
                                              plan.productAddonss[product][k].plan_level.disallowedPlanLevels,
                                              plan.planOptions,
                                              group.parentId,
                                              package.name,
                                              group.name,
                                              plan.planCoverage,
                                              0,
                                              0,
                                              0,
                                              0,
                                              $event,
                                              i,
                                              j,
                                              k,
                                              plan,
                                              plan.productAddonss[product][k],package,group,coverage.planCoverageUI)">
        
                                        </div>
        
                                        <div style="margin-top: -1px">
                                          {{ coverage.planCoverageUI }}
                                        </div>
                                      </div>
                                      <div
                                        class=""
                                        [style.color]="
                                          plan.isBundle == false
                                            ? plan.productAddonss[product][0]?.planlevel
                                                ?.backgroundColor || '#5E172E'
                                            : group.backgroundColor || '#5E172E'
                                        "
                                      >
                                        {{ currencySymbol
                                        }}{{ coverage.price | number : "1.2-2"
                                        }}<small>*</small>
                                      </div>
                                    </div>
        
                                    <!-- <span class="overflow-ellipsis2" style="float: right; color: white">
                        {{ currencySymbol}}{{ coverage.price | number:
                        "1.2-2"}}<small>*</small></span>
                      <span class="overflow-ellipsis" style="float: left; color: white"
                        title={{coverage.planCoverageUI}}>
                        <span> <input type="checkbox" [disabled]="package.selected"
                            [checked]="coverage.selected"
                            id="plancheck{{ plan.productAddonss[product][k].id }}"
                            class="plancheckbox{{ package.id }} plancv"
                            attr.data="{{ package.name }}##{{ group.name }}##{{
                            plan.planCoverage
                            }}##{{plan.productAddonss[product][k].calculatedTax?.price}}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                            plan.frqMonthly
                            }}##{{ package.optIn }}##{{
                            group.disallowedPlanLevels
                            }}##{{ group.parentId }}##{{ group.id }}##{{
                            plan.name
                            }}##{{ plan.planLevel }}##{{ plan.packageId }}##0##{{plan.planOptions}}##{{plan.productAddonss[product][k].id}}" (change)="
                            onCheckboxChange(
                              $event,
                              package.allowMultiple,
                              group.disallowedPlanLevels,
                              plan.planOptions,
                              group.parentId,
                              package.name,
                              group.name,
                              plan.planCoverage,
                              0,
                              0,
                              0,
                              0,
                              $event,
                              i,
                              j,
                              k,
                              plan,
                              plan.productAddonss[product][k],package,group
                            )
                          "></span>
        
        
                        <span>{{coverage.planCoverageUI}}</span>
                      </span><span class="clearfix"></span> -->
                                  </li>
                                </div>
                              </div>
                              </div>
        
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="showPlanDetails == true" style="margin-top: 800px;">


                    <div *ngFor="let package of mainarrayFinal;let a =index" class="plansscreen">
    
                      <span style="color:black">{{package?.name}}</span>
    
                      <div class="wraptext">
                        <div *ngFor="let group of package.groups;let k=index">
                          <div *ngFor="let plan of group.plans; let i = index">
                            <div *ngIf="plan.insuranceType!='LIFE'">
                              <div class="package-groups col-md-4" *ngFor="let product of plan.productAddonssNames; let r = index"
                                title=""
                                [style.background-color]="
                                                                              plan.isBundle==false?plan.productAddonss[product][0].planlevel.backgroundColor:group.backgroundColor||'#5E172E'">
    
                                <span class="plantitle"> <span style="color: white"
                                    *ngIf="group.categorization.paidByCompany==1">Company Paid Plans</span>
                                  <span style=" color: white" *ngIf="group.categorization.coveredByCompany==1">Upgrade Plans</span>
                                  <span style=" color: white"
                                    *ngIf="group.categorization.paidByEmployee==1">Voluntary Benefit(s) Plans</span><br><span
                                    style="padding-left:5px">{{product}}</span></span>
    
                                <div class="plancoverage ">
                                  <div class="plansCoverageDetails row col-12"
                                    *ngFor="let coverage of  plan.productAddonss[product]; let k = index">
    
                                    <!-- <span class="overflow-ellipsis2" style="float: right; color: white"
                                                                *ngIf="group.categorization.paidByCompany==1">&nbsp;<span
                                                                  style="float:right;color:white;font-size: 14px;">{{
                                                                  currencySymbol}}0.00<small>*</small></span></span> -->
    
    
    
                                    <div class="col-4">
                                      <span class="overflow-ellipsis" style="float: left; color: white" title={{coverage.planCoverageUI}}>
    
                                        <input type="checkbox"
                                          id="plancheck{{plan.isBundle?plan.id:plan.productAddonss[product][k].planlevel.id }}"
                                          class="plancheckbox{{ package.id }} plancv newPlan{{plan.id}} {{group.categorization.paidByCompany==1?'cp_plan':group.categorization.coveredByCompany==1?'cc_plan':'ep_plan'}} coverage{{coverage.planCoverageUI | uppercase}}"
                                          attr.data="{{ package.name }}##{{ group.name }}##{{
                                     plan.planCoverage
                                   }}##{{plan.productAddonss[product][k].calculatedTax.price}}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                                     plan.frqMonthly
                                   }}##{{ package.optIn }}##{{
                                     group.disallowedPlanLevels
                                   }}##{{ group.parentId }}##{{ group.id }}##{{
                                     plan.name
                                   }}##{{ plan.planLevel }}##{{ plan.packageId }}##0##{{plan.planOptions}}##{{plan.productAddonss[product][k].id}}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}##{{plan.products && plan.products[k]?.upgradeCalculation?true:false}}"
                                          (change)="
                                                                             onCheckboxChangeCorporate(
                                       $event,
                                       package.allowMultiple,
                                       plan.productAddonss[product][k].plan_level.disallowedPlanLevels,
                                       plan.planOptions,
                                       group.parentId,
                                       package.name,
                                       group.name,
                                       plan.planCoverage,
                                       0,
                                       0,
                                       0,
                                       0,
                                       $event,
                                       i,
                                       k,
                                       plan,
                                       plan.productAddonss[product][k],package,group)">
    
                                        {{coverage.planCoverageUI}}</span><span class="clearfix"></span>
                                    </div>
                                    <div class="col-8">
                                      <span class="overflow-ellipsis2" style="float: right; color: white"
                                        *ngIf="group.categorization.paidByCompany==1">
                                        <span *ngIf="plan.products;else noProducts">
                                          <span *ngIf="plan.products[k] && plan.products[k].upgradeCalculation;else block1">
                                            <span *ngIf="plan.products[k].upgradeCalculation.deltaplanPrice<=0;else deltaplanPriceCheck">
                                              <span style="font-size: 14px;">You pay {{
                                                currencySymbol}}0.00<small>*</small></span>
                                            </span>
                                            <ng-template #deltaplanPriceCheck>
                                              <span style="font-size: 14px;float:right;color:white"> You pay through payroll deduction
                                                {{
                                                currencySymbol}}{{plan.products[k].upgradeCalculation.deltaplanPrice | number:
                                                "1.2-2"}}<small>*</small></span>
                                            </ng-template>
                                          </span>
                                          <ng-template #block1>
                                            <span *ngIf="plan.upgradeCalculation;else block2">
                                              <span *ngIf="plan.upgradeCalculation.deltaplanPrice<=0;else noDeltaplanPrice">
                                                <span style="font-size: 14px;color:white">You pay {{
                                                  currencySymbol}}0.00<small>*</small></span>
    
                                              </span>
                                              <ng-template #noDeltaplanPrice>
                                                <span style="font-size: 14px;float:right;color:white">You pay through payroll deduction
                                                  {{
                                                  currencySymbol}}{{plan.upgradeCalculation.deltaplanPrice | number:
                                                  "1.2-2"}}<small>*</small></span>
                                              </ng-template>
                                            </span>
                                          </ng-template>
                                          <ng-template #block2>
                                            <span>
                                              <span style="font-size: 14px;color:white">You pay {{
                                                currencySymbol}}0.00<small>*</small></span>
    
                                            </span>
    
                                          </ng-template>
    
    
                                        </span>
                                        <ng-template #noProducts>
                                          <span style="font-size: 14px;color:white">You pay {{
                                            currencySymbol}}0.00<small>*</small></span>
    
                                        </ng-template>
                                      </span>
    
                                      <span class="overflow-ellipsis2" style="float: right; color: white"
                                        *ngIf="group.categorization.coveredByCompany==1">
                                        <span style="float:right;color:white;font-size: 14px;">{{
                                          currencySymbol}}{{(plan.products?plan.products[k].upgradeCalculation.deltaplanPrice:plan.upgradeCalculation.deltaplanPrice)
                                          | number:
                                          "1.2-2"}}<small>*</small></span></span>
                                      <span class="overflow-ellipsis2" style="float: right; color: white"
                                        *ngIf="group.categorization.paidByEmployee==1"><span
                                          style="float:right;color:white;font-size: 14px;">{{
                                          currencySymbol}}{{coverage.price |
                                          number: "1.2-2" }}<small>*</small></span></span>
                                    </div>
                                  </div>
                                  <div class="taxes">
                                    <span *ngIf="group.categorization.paidByCompany==1" style="color:white">*Employee Pays</span>
                                    <span
                                      *ngIf="group.categorization.coveredByCompany==1" style="color:white">*Employee pays through payroll deduction</span>
                                    <span *ngIf="group.categorization.paidByEmployee==1" style="color:white"
                                      class="my-2">* Employee pays through CC/PAD</span>
    
                                  </div>
                                </div>
    
    
                                <!-- Member -->
    
    
    
    
    
                              </div>
                            </div>
    
    
    
                          </div>
                        </div>
                      </div>
    
    
                    </div>
                  </div>

              
            </div>
            <div class="modal-footer py-2" *ngIf="!showDependentForm">

              <div style="display: flex; gap:10px;">

                <div *ngIf="enactMode == 'add' && addToPolicy == 'open'">
                  <select  class="form-select border border-dark" id="effectiveDate" placeholder="Select"
                  [(ngModel)]="finalEffectiveDate" (change)="handleEffectiveDateChange()">
                  <option value="null" label="" selected disabled>Select Effective date</option>
                  <option *ngFor="let name of planEnrollmentDates" [value]="name" [label]="name">
                    {{ name }}
                  </option>
                </select>
              </div>

              <div *ngIf="(enactMode == 'delete' && normalDependentDeletion == false) || (enactMode == 'cob' && isNeedToUpdate == true)">
                <select  class="form-select border border-dark" id="effectiveDate" placeholder="Select"
                [(ngModel)]="finalEffectiveDate" (change)="onEffectiveDateChange()">
                <option value="null" label="" selected disabled>Select Effective date</option>
                <option *ngFor="let name of planEnrollmentDates" [value]="name" [label]="name">
                  {{ name }}
                </option>
              </select>
            </div>


              <button type="button" class="btn btn-sm btn-light" id="cancelButton"
                    data-bs-dismiss="modal"
                    (click)="closeDependentForm()" *ngIf="enactMode == 'add'  || enactMode == 'cob' || enactMode == 'maritalChange'">
                    {{ lang?.Cancel }}
                </button>
                <button  data-bs-dismiss="modal" type="button" class="btn btn-sm btn-light" id="cancelButton" (click)="cancelDeletion()"
                    *ngIf="enactMode == 'delete'">
                    Cancel
                </button>
                <button type="button" *ngIf="dependentUpdate && enactMode == 'add'"
                    class="btn btn-sm btn-light" id="updateButton" (click)="updateDependent()">
                    {{ lang?.Update }}
                </button>
                <button type="button" *ngIf="enactMode == 'cob' && !proceedDeleteButtonDisabled"
                class="btn btn-sm btn-light" id="updateButton" (click)="updateCobInfo()">
                Proceed
            </button>
            <button type="button" *ngIf="enactMode == 'maritalChange'"
                class="btn btn-sm btn-light" id="updateButton" (click)="updateMaritalStatus()">
                Update
            </button>
                <button type="button" *ngIf="validateCheck && enactMode == 'add' && !showDependentForm && addToPolicy == 'open'  && !proceedDeleteButtonDisabled"
                    class="btn btn-sm btn-light" id="updateButton2" (click)="addDependent_v2Configuration()">
                    Proceed
                </button>

                <button type="button" *ngIf="validateCheck && enactMode == 'add' && !showDependentForm && addToPolicy == 'close'"
                    class="btn btn-sm btn-light" id="updateButton2" (click)="addDependent_v2Configuration()">
                    Update
                </button>
                <button type="button" class="btn btn-sm btn-light" id="updateButton2" (click)="deleteDependent_v2Configuration()"
                    *ngIf="enactMode == 'delete' && normalDependentDeletion == false && !proceedDeleteButtonDisabled">
                    Proceed
                </button>

                 <button type="button" class="btn btn-sm btn-light" id="updateButton2" (click)="addDependent_v2Confirmation()"
                    *ngIf="enactMode == 'delete' && normalDependentDeletion == true">
                    Update
                </button>
              </div>
                
                
              
                
                <!-- <button
        type="button"
        *ngIf="dependentType=='spouse'"
        class="btn btn-sm btn-light"
        id="updateButton"
        (click)="showAddDependentForm()"
        >
        Add Children
        </button> -->
            </div>

            <div *ngIf="showDependentForm==true" class="modal-footer py-2">
                <div class="row">
                    <div
                        style="height: 40px; width: 100%; display: flex; align-items:center; justify-content: end; gap:10px;">
                        <button type="button" class="btn btn-sm btn-light" id="cancelButton"
                            (click)="closeAddDependentForm()">Cancel</button>
                        <button type="button" class="btn btn-sm btn-light" id="updateButton"
                            (click)="handleChildDetails_v2New()" style="margin-right: 10px;"
                            *ngIf="!editChildUpdate">Add Child</button>
                        <button type="button" class="btn btn-sm btn-light" id="updateButton"
                            (click)="handleChildDetails_v2New()" style="margin-right: 10px;"
                            *ngIf="editChildUpdate">Update Child</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Not using -->
<div id="addChildModal" class="modal fade modalposition modal-md " tabindex="-1" aria-labelledby="addChildModalLabel"
    aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content" id="dependent-content">
            <div class="modal-header" id="backgroundColor">
                <span class="modal-title">Enact Life Event Change</span>
                <i #closeDependentmodal class="bi bi-x-circle" role="button" aria-hidden="true"
                    data-bs-dismiss="modal"></i>
            </div>
            <div class="modal-body" style="text-align: left; color:black">

                <form [formGroup]="dependentform">


                    <div class="isInsuranceCheck" style="display: flex; gap: 30px;">
                        <div class="leftSide">
                            <div class="row" style="display: flex; align-items: end;">
                                <div class="col-12 form-group">
                                    <label id="modal-labels">Is your Child currently covered by another Health and/or
                                        Dental Insurance plan?
                                        <span style="color: red">*</span></label>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-3 mt-1">
                                    <input type="radio" [value]="true" name="coveredByAnotherPlan"
                                        formControlName="coveredByAnotherPlan" [checked]="childCoverage === true"
                                        (click)="openChildCoverage('open')" />&nbsp;<label id="radio-labels"
                                        class="align-text-top">{{
                                        lang?.Yes
                                        }}</label>
                                </div>
                                <div class="col-3 mt-1">
                                    <input type="radio" [value]="false" name="coveredByAnotherPlan"
                                        formControlName="coveredByAnotherPlan" [checked]="childCoverage === false"
                                        (click)="openChildCoverage('close')" />&nbsp;<label id="radio-labels"
                                        class="align-text-top">{{
                                        lang?.No
                                        }}</label>
                                </div>
                                <div *ngIf="
                    dependentForm['coveredByAnotherPlan'].touched &&
                    dependentForm['coveredByAnotherPlan'].invalid
                " class="help-block text-danger">
                                    <div *ngIf="
                    dependentForm['coveredByAnotherPlan'].errors &&
                    dependentForm['coveredByAnotherPlan'].errors['required']
                    ">
                                        {{ lang?.Please_choose_dependent_insurance_status }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="rightSide" style="flex-grow: 1;">
                            <div class="row">
                                <div class="col-8 form-group"
                                    *ngIf="childCoverage && dependentChildCoverage === 'open'">
                                    <label id="modal-labels">{{ lang?.Name_of_the_Carrier
                                        }}<span style="color: red">*</span></label>
                                    <input type="text" placeholder="Name of the Carrier" class="form-control"
                                        formControlName="carrierName" id="carrierName" (keypress)="
                    (($event.charCode >= 65 && $event.charCode < 91) ||
                        ($event.charCode >= 97 && $event.charCode < 123) ||
                        $event.charCode == 32)
                    " (input)="checkFirstCharacter($event, pureDependentform)" />
                                    <div *ngIf="
                    dependentForm['carrierName'].touched &&
                    dependentForm['carrierName'].invalid
                    " class="help-block text-danger">
                                        <div *ngIf="
                        dependentForm['carrierName'].errors &&
                        dependentForm['carrierName'].errors['required']
                    ">
                                            {{ lang?.Please_enter_name_of_carrier }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row" style="display: flex;  align-items: center; margin-top: 5px; margin-bottom: 5px;"
                        *ngIf="enactMode === 'add' && dependentType == 'spouse' || dependentType == 'multiple'">



                        <div class="col-5 form-group">
                            <label id="modal-labels">Child Name<span style="color: red">*</span></label>
                            <input type="text" class="form-control" id="reasonForLate" [(ngModel)]="reasonForLate">
                        </div>

                        <div class="col-3 form-group">
                            <label id="modal-labels">Date of birth<span style="color: red">*</span></label>
                            <input type="text" placeholder="MM-DD-YYYY" class="form-control checking-field"
                                id="spouseDob" [(ngModel)]="spouseDob_" [minDate]="minDatechild"
                                [maxDate]="maxDatechild" bsDatepicker [bsConfig]="{ dateInputFormat: 'MM-DD-YYYY' }" />
                        </div>


                        <div class="col-4 form-group" *ngIf="coveredByAnotherPlan == 'open'">
                            <label id="modal-labels">Insurance carrier<span style="color: red">*</span></label>
                            <input type="text" class="form-control" id="reasonForLate" [(ngModel)]="reasonForLate">
                        </div>
                    </div>




                    <div class="row"
                        *ngIf="enactMode === 'add' && dependentType == 'spouse' || dependentType == 'multiple'"
                        style="margin-top: 5px; margin-bottom: 5px;">
                        <div class="col-md-6 form-group">
                            <label id="modal-labels" *ngIf="dependentType == 'child'">Add Child(ren) to your policy?
                                <span style="color: red">*</span></label>
                        </div>

                        <div class="col-2 mt-1" style="display: flex; align-items: center; gap:1px;">
                            <input type="radio" [value]="true" name="addToPolicy" [(ngModel)]="addToPolicy"
                                [checked]="addToPolicy === 'open'" (click)="handleAddToPolicy('open')" />&nbsp;<label
                                id="radio-labels" class="align-text-top">{{
                                lang?.Yes
                                }}</label>
                        </div>
                        <div class="col-2 mt-1" style="display: flex; align-items: center; gap:1px;">
                            <input type="radio" [value]="false" name="addToPolicy" [(ngModel)]="addToPolicy"
                                [checked]="addToPolicy === 'close'" (click)="handleAddToPolicy('close')" />&nbsp;<label
                                id="radio-labels" class="align-text-top">{{
                                lang?.No
                                }}</label>
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-md-8 align-items-center">
                            <div class="row">
                                <div class="col-1" id="checkbox">
                                    <input type="checkbox" value="true" formControlName="specialNeeds"
                                        [checked]="specialNeeds === 'true'" />
                                </div>
                                <div class="col-11">
                                    <b id="modal-labels">{{
                                        lang?.Dependent_with_Special_Needs
                                        }}</b>&nbsp;<i class="bi bi-info-circle"></i>
                                </div>
                            </div>
                        </div>
                        <!-- <div *ngIf="dependentForm['specialNeeds'].touched && dependentForm['specialNeeds'].invalid" class="help-block text-danger">
                            <div *ngIf="dependentForm['specialNeeds'].errors && dependentForm['specialNeeds'].errors['required']">Please enter</div>
                        </div> -->
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-8 align-items-center">
                            <div class="row">
                                <div class="col-1" id="checkbox">
                                    <input type="checkbox" value="true" formControlName="postSecondaryStudent"
                                        [checked]="postSecondaryStudent === true"
                                        (change)="openGraduationDate($event)" />
                                </div>
                                <div class="col-11">
                                    <b id="modal-labels">{{ lang?.Post_Secondary_Student }}</b>&nbsp;<i
                                        class="bi bi-info-circle"></i>
                                </div>
                            </div>
                        </div>
                        <!-- <div *ngIf="dependentForm['postSecondaryStudent'].touched && dependentForm['postSecondaryStudent'].invalid" class="help-block text-danger">
                            <div *ngIf="dependentForm['postSecondaryStudent'].errors && dependentForm['postSecondaryStudent'].errors['required']">lang?.Please_enter_first_name</div>
                        </div> -->
                    </div>
                    <div class="row">

                        <div class="col-md-3 col-3 form-group" *ngIf="postSecondaryStudent && graduationDate">
                            <label id="modal-labels">{{ lang?.Graduation_Day
                                }}<span style="color: red">*</span></label>
                            <!-- <input type="text" placeholder="mm-dd-yyyy" class="form-control date" name="graduationDate" formControlName="graduationDate"> -->
                            <input type="text" placeholder="MM-DD-YYYY" class="form-control checking-field"
                                name="graduationDate" formControlName="graduationDate" placement="top"
                                [minDate]="minDatechild" [maxDate]="maxDatechild" bsDatepicker
                                [bsConfig]="{ dateInputFormat: 'MM-DD-YYYY' }" />
                        </div>


                        <!-- <div *ngIf="dependentCoverage === 'open'" class="col-3 form-group">
            <label id="modal-labels"
                >Upgrade Plan<span style="color: red">*</span>
                <i style="margin-left: 5px;" class="fa fa-info-circle" title="Upgrading your plan will result in a price change, but you can keep the same coverage." aria-hidden="true"></i>
                </label
            >
            <select class="form-select" formControlName="upgradePlan" (change)="handleUpgradePlan2($event)">
                <option value="" disabled>Select</option>
                <option
                value="true"
            >
                Yes
            </option>
                <option
                value="false"
            >
                No
            </option>
            </select>
            <div
                *ngIf="
                dependentForm['carrierName'].touched &&
                dependentForm['carrierName'].invalid
                "
                class="help-block text-danger"
            >
                <div
                *ngIf="
                    dependentForm['carrierName'].errors &&
                    dependentForm['carrierName'].errors['required']
                "
                >
                {{ lang?.Please_enter_name_of_carrier }}
                </div>
            </div>
            </div> -->


                        <div *ngIf="
                dependentForm['graduationDate'].touched &&
                dependentForm['graduationDate'].invalid
            " class="help-block text-danger">
                            <div *ngIf="
                dependentForm['graduationDate'].errors &&
                dependentForm['graduationDate'].errors['required']
                ">
                                {{ lang?.Please_choose_graduation_date }}
                            </div>
                        </div>
                    </div>

                </form>
            </div>

            <div class="modal-footer py-2">

                <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
                    (click)="closeHandleChildDetails()">Cancel</button>
                <button type="button" class="btn btn-sm btn-light" id="updateButton"
                    (click)="handleChildDetails_v2New()" style="margin-right: 10px;"
                    *ngIf="!editChildUpdate">Add</button>
                <button type="button" class="btn btn-sm btn-light" id="updateButton"
                    (click)="handleChildDetails_v2New()" style="margin-right: 10px;"
                    *ngIf="editChildUpdate">Update</button>
            </div>
        </div>
    </div>
</div>


<div
id="showPlanSummaryBrief"
class="modal fade modalposition modal-md"
data-bs-backdrop="static"
>
<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content" id="dependent-content">
    <div class="modal-header" id="backgroundColor">
        <span class="modal-title">Confirmation of Life Event Change 
            <span *ngIf="dependentType == 'spouse' && enactMode == 'add'">(Add Spouse)</span>
            <span *ngIf="dependentType == 'child' && enactMode == 'add'">(Add Child(ren))</span>
            <span *ngIf="dependentType == 'multiple' && enactMode == 'add'">(Add Spouse & Child(ren))</span>

            <span *ngIf="dependentType == 'spouse' && enactMode == 'delete'">(Remove Spouse)</span>
            <span *ngIf="dependentType == 'child' && enactMode == 'delete'">(Remove Child(ren))</span>
            <span *ngIf="dependentType == 'multiple' && enactMode == 'delete'">(Remove Spouse & Child(ren))</span>
        </span>
        <i
        #closeDependentmodal
        class="bi bi-x-circle"
        role="button"
        aria-hidden="true"
        data-bs-dismiss="modal"
        ></i>
    </div>
    <div  class="modal-body" style="text-align: left; color:black; font-size: 12px;">
      <span *ngIf="underwritingHeading">{{underwritingHeading}}</span>
      <span>
        Please review changes below and confirm to continue.
      </span><br/>

       <ul>
        <li *ngIf="firstConfirmMessage">{{ firstConfirmMessage }}</li>
        <li *ngIf="secondConfirmMessage">{{ secondConfirmMessage }}</li>
        <!-- <li *ngIf="effectedPackageNames?.length">{{ effectedPackageNames.join(', ') }}</li> -->
        <li *ngIf="secondMessage">{{ secondMessage }}</li>
        <li *ngIf="underWritingMessage1">{{ underWritingMessage1 }}</li>
        <li *ngIf="underWritingMessage2">{{ underWritingMessage2 }}</li>
        <li *ngIf="corpMessage">{{ corpMessage }}</li>
        <li *ngIf="specialConditionMessage">{{specialConditionMessage}}</li>        

      </ul>
      
      
    </div>

    <div class="modal-footer py-2">
        <button
        type="button"
        class="btn btn-sm btn-light"
        data-bs-dismiss="modal"
        id="cancelButton"
        (click)="closeaddDependent_v2Confirmation()"
        >
        Back</button
        >&nbsp;&nbsp;
        <button
        type="button"
        *ngIf="validateCheck"
        class="btn btn-sm btn-light"
        id="updateButton2"
        (click)="addDependent_v2Confirmation()"
        style="width: 64px;"
        >
        Confirm
        </button>
        <!-- <button
        type="button"
        *ngIf="dependentType=='spouse'"
        class="btn btn-sm btn-light"
        id="updateButton"
        (click)="showAddDependentForm()"
        >
        Add Children
        </button> -->
    </div>
    </div>
</div>

                